import { Colaborador } from '@/store/catalogos/colaborador';
import { FormatosReporteModel } from '@/store/catalogos/formatosReporte';
import { properties } from '@/utils/properties';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class FormatosReporteService {
  private readonly baseUrl = properties.URL_CATALOGOS + 'formatos';

  constructor(private http: HttpClient) { }

  getAll(): Observable<FormatosReporteModel[]> {
    return this.http.get<FormatosReporteModel[]>(this.baseUrl, httpOptions);
  }

  update(formato: FormatosReporteModel): Observable<FormatosReporteModel> {
    return this.http.put<FormatosReporteModel>(`${this.baseUrl}/${formato.idFormatoReporte}`, formato, httpOptions);
  }

  create(formato: FormatosReporteModel): Observable<FormatosReporteModel> {
    return this.http.put<FormatosReporteModel>(`${this.baseUrl}/${formato.idFormatoReporte}`, formato, httpOptions);
  }
}
